import gql from "graphql-tag"

import contentAuthor from "../contentAuthor"
import homeVideo from "../homeVideos/homeVideo"
import image from "../image"
import newsSource from "./newsSource"

const news = gql`
  ${contentAuthor}
  ${homeVideo}
  ${image}
  ${newsSource}

  fragment News on News {
    author {
      ...ContentAuthor
    }
    createdAt
    homeVideo {
      ...HomeVideo
    }
    id
    images {
      ...Image
    }
    isPublished
    name
    publishedAt
    slug
    sources {
      ...NewsSource
    }
    subheading
    text
    updatedAt
  }
`

export default news
